import { render } from "./DataSourceInstanceForm.vue?vue&type=template&id=354c8b13"
import script from "./DataSourceInstanceForm.vue?vue&type=script&lang=ts"
export * from "./DataSourceInstanceForm.vue?vue&type=script&lang=ts"
script.render = render

export default script